(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donate-modal"]) return;
  try {
    
	$('#modal-donate .ProductForm__AddToCart').click(function(){
$('.PageOverlay').addClass('is-visible');
});


  } catch(e) { console.error(e); }
})();
})();
